import React from "react";
import Hammer from 'react-hammerjs';
import { tapOptions } from '../../utils/hammerOptions';

import backspaceButton from '../../assets/backspace-btn.png'
import '../../css/keyboard.css'

let keyRows = [ 
  [
    'Q',
    'W',
    'E',
    'R',
    'T',
    'Y',
    'U',
    'I',
    'O',
    'P',
  ],
  [
    'A',
    'S',
    'D',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
  ],
  [
    'Z',
    'X',
    'C',
    'V',
    'B',
    'N',
    'M',
  ]
];

class Keyboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this._handleClick = this._handleClick.bind(this);
  }
  _handleClick(c) {
    this.props.clickHandler(c);
  }

  render() {
    let keyboardButtons = keyRows.map( (row, i) => {
      let currentRow = row.map( (character) => {
        return (
          <Hammer onTap={() => this._handleClick(character)} options={tapOptions} key={character} >
            <div className="keyboardButton large-1" >
              {character}
            </div>
          </Hammer>
        ) 
      });
      // Add Backspace Button to end of 3rd row
      if (i === 2) {
        currentRow.push(
          <Hammer onTap={() => this._handleClick("BACKSPACE")} options={tapOptions} key='backspace'>
            <div className="backspace keyboardButton" >
              <img src={backspaceButton} />
            </div>
          </Hammer>
        )
      }

      return <div className="keyboardRow" key={i}>{currentRow}</div>
    });
    return (
      <div className="keyboard">
        {keyboardButtons}
      </div>
    );
  }
}

export default Keyboard;



// WEBPACK FOOTER //
// ./src/components/FinalizeJourney/Keyboard.js